import { Component } from '@verndale/core';

class ShareThis extends Component {
  setupDefaults() {
    this.dom = {
      twitter: this.el.querySelector('[data-service="twitter"]'),
      linkedin: this.el.querySelector('[data-service="linkedin"]'),
      facebook: this.el.querySelector('[data-service="facebook"]'),
      link: this.el.querySelector('[data-service="link"]')
    };

    this.url = window.location.href;
  }

  addListeners() {
    if (this.dom.twitter) {
      this.dom.twitter.addEventListener('click', this.twitterShare.bind(this));
    }
    if (this.dom.linkedin) {
      this.dom.linkedin.addEventListener(
        'click',
        this.linkedinShare.bind(this)
      );
    }
    if (this.dom.facebook) {
      this.dom.facebook.addEventListener(
        'click',
        this.facebookShare.bind(this)
      );
    }
    if (this.dom.link) {
      this.dom.link.addEventListener('click', this.copyLink.bind(this));
    }
  }

  twitterShare() {
    this.openModal(`https://twitter.com/share?url=${this.url}`);
  }

  linkedinShare() {
    this.openModal(
      `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`
    );
  }

  facebookShare() {
    this.openModal(`https://www.facebook.com/share.php?u=${this.url}`);
  }

  copyLink() {
    const linkInitial = this.el.querySelector('.share-this__link-initial');
    const linkReady = this.el.querySelector('.share-this__link-ready');

    navigator.clipboard.writeText(this.url);
    linkInitial.style.display = 'none';
    linkReady.style.display = 'block';

    setTimeout(() => {
      linkInitial.style = null;
      linkReady.style = null;
    }, 3000);
  }

  openModal(url) {
    const winTop = window.innerHeight / 3 - 200;
    const winLeft = window.innerWidth / 2 - 300;

    window.open(
      url,
      'sharer',
      `top=${winTop}, left=${winLeft}, width=600, height=400, scrollbars=no`
    );
  }
}

export default ShareThis;
